var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNetwork(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#074673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41a1c8"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.294,2.25a2.21,2.21,0,0,0-1.659,3.666,2.184,2.184,0,0,0,1.194.7V7.966L10.5,9.7,7.175,7.966V6.619a2.208,2.208,0,1,0-2.128-.7,2.184,2.184,0,0,0,1.194.7V8.412a.219.219,0,0,0,.122.2l3.672,1.9v1.372a2.207,2.207,0,1,0,2.125.7,2.184,2.184,0,0,0-1.194-.7V10.509l3.672-1.9a.219.219,0,0,0,.122-.2V6.619a2.21,2.21,0,0,0-.466-4.369ZM5.431,4.459A1.275,1.275,0,1,1,6.706,5.734,1.276,1.276,0,0,1,5.431,4.459Zm6.344,9.581A1.275,1.275,0,1,1,10.5,12.766,1.276,1.276,0,0,1,11.775,14.041Zm2.519-8.3a1.275,1.275,0,1,1,1.275-1.275A1.276,1.276,0,0,1,14.294,5.738Z",
    transform: "translate(-4.5 -2.25)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.2ba9afb282d7707e8f4a18c343bc8c08.svg";
export { ForwardRef as ReactComponent };